// extracted by mini-css-extract-plugin
export var label = "_ai-1";
export var reminder = "_ai-0";